import React from "react";
import ProspectDetails from "./ProspectDetails";
import ProspectExperience from "./ProspectExperience";
import ProspectEducation from "./ProspectEducation";
import ProspectOrganization from "./ProspectOrganization";

const ExperienceEducationOrganization = ({
  profileData,
  setLoading,
  expDetails,
  eduDetails,
  organizationData,
  setOrganizationData,
  isDownloading,
  
  
}) => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          width: "100%",
          gap: "20px",
          marginBottom: "22px",
        }}
      >
        <ProspectExperience
          profileData={profileData}
          expDetails={expDetails}


        />
        <ProspectEducation
          profileData={profileData}
          eduDetails={eduDetails}


        />
      </div>
      <div
      // style={{ pageBreakInside: "avoid", breakBefore: "page" }}
      >
      <ProspectOrganization
        setLoading={setLoading}
        organizationData={organizationData}
        setOrganizationData={setOrganizationData}
        isDownloading={isDownloading}
      />
      </div>
    </div>
  );
};

export default ExperienceEducationOrganization;
